import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Head from 'next/head';
import ReviewList from 'components/layout/Review/List';
import Header from 'components/ui/Header/Header';
export var __N_SSP = true;
export default function ReviewAuthorList(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("meta", {
        name: "robots",
        content: "noindex"
      })
    }), /*#__PURE__*/_jsx(Header, {
      useHome: true,
      title: "\uC0AC\uC6A9\uC790 \uD6C4\uAE30 \uBAA8\uC544\uBCF4\uAE30"
    }), /*#__PURE__*/_jsx("div", {
      className: "view",
      children: /*#__PURE__*/_jsx(ReviewList, {
        type: "author",
        author: props.author
      })
    })]
  });
}